export default "__VITE_ASSET__0d9b1608__"